/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
  GetApiV1ClassroomdisciplineSharedClassModulesQueryParams,
  GetApiV1ClassroomdisciplineSharedClassModules401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassModules.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineSharedClassModules } from "../../clients/classPlanningSharedController/getApiV1ClassroomdisciplineSharedClassModules.ts";

export const getApiV1ClassroomdisciplineSharedClassModulesQueryKey = (
  params?: GetApiV1ClassroomdisciplineSharedClassModulesQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/shared/class-modules" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineSharedClassModulesQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineSharedClassModulesQueryKey
>;

export function getApiV1ClassroomdisciplineSharedClassModulesQueryOptions(
  params?: GetApiV1ClassroomdisciplineSharedClassModulesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1ClassroomdisciplineSharedClassModulesQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassModules401>,
    GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineSharedClassModules(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de módulos de aula (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/class-modules}
 */
export function useGetApiV1ClassroomdisciplineSharedClassModules<
  TData = GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineSharedClassModulesQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineSharedClassModulesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
        ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassModules401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineSharedClassModulesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineSharedClassModulesQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassModules401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
